/**
 * Meta Pixel loader. The script is injected on demand (first interaction or a
 * short delay) so ~200 KB of analytics never competes with the hero image.
 */
const PIXEL_ID = '2475458309526241'

type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFn
    _fbq?: FbqFn
  }
}

let initialized = false

export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (!window.fbq) {
    const fbq: FbqFn = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as FbqFn
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImg = document.createElement('img')
    pixelImg.height = 1
    pixelImg.width = 1
    pixelImg.style.display = 'none'
    pixelImg.alt = ''
    pixelImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImg)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  initMetaPixel()
  window.fbq?.('track', event, params)
}
